import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Soins from "../pages/soins/page";
import Univers from "../pages/univers/page";
import Contact from "../pages/contact/page";
import RdvPage from "../pages/rdv/page";
import GaleriePage from "../pages/galerie/page";
import Temoignages from "../pages/temoignages/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/soins",
    element: <Soins />,
  },
  {
    path: "/univers",
    element: <Univers />,
  },
  {
    path: "/galerie",
    element: <GaleriePage />,
  },
  {
    path: "/temoignages",
    element: <Temoignages />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/rdv",
    element: <RdvPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;